"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.URL_CODE = void 0;
var URL_CODE = {
  DIVINO_AMOR: 126,
  FEMME_APP: 176,
  G_ENCONTROS: 125,
  MATCH_AR: 128,
  MATCH_AU: 54,
  MATCH_BR: 127,
  MATCH_CL: 130,
  MATCH_CO: 131,
  MATCH_CR: 134,
  MATCH_EC: 137,
  MATCH_GT: 138,
  MATCH_HK: 118,
  MATCH_JP: 94,
  MATCH_KR: 114,
  MATCH_LATAM: 135,
  MATCH_LATINO: 136,
  MATCH_MX: 129,
  MATCH_NZ: 56,
  MATCH_PE: 132,
  MATCH_TW: 115,
  MATCH_VE: 133,
  MATCH: 1,
  OUR_TIME_AR: 180,
  OUR_TIME_BR: 174,
  OUR_TIME_MX: 179,
  PAR_PERFEITO: 124,
  SINGLE_PARENT_MEET_BR: 173,
  SINGLE_PARENT_MEET: 148,
  STIR: 181
};
exports.URL_CODE = URL_CODE;